import React, { useEffect } from 'react';
import { MemoryRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './Header'
import routeList from '../routes'
import { hotjar } from 'react-hotjar';

/**
* Main component
*/
const App = () => {
  const { REACT_APP_HOTJAR_ID, REACT_APP_HJSV } = process.env;
  useEffect(() => {
    hotjar.initialize(REACT_APP_HOTJAR_ID, REACT_APP_HJSV);
  }, []);
  return (
    <main>
      <Router>
        <Header />
        <article className='app'>
          <div className='app__container'>
            <Switch>
              {routeList.map((route, i) => <Route key={i} path={route.path} component={route.component} />)}
            </Switch>
          </div>
        </article>
      </Router>
    </main >
  );
}

export default App;